import React from 'react';
import DocTypeWrapper from './DocTypeWrapper';
import Heading from './Heading';
import Description from './TsDocComment';
import Members from './TsDocMembers';
import TsDocTypeExpression from './TsDocTypeExpression';
import { getReturnType } from './utils/tsDocTypeExpression';

function TsDocReturnBlock(_ref) {
  var definition = _ref.definition,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth;
  var returnType = getReturnType(definition);
  return /*#__PURE__*/React.createElement(React.Fragment, null, definition.type && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: depth
  }, "Return Value", ' ', /*#__PURE__*/React.createElement(DocTypeWrapper, null, /*#__PURE__*/React.createElement(TsDocTypeExpression, {
    type: returnType,
    compact: true
  }))), /*#__PURE__*/React.createElement(Description, {
    comment: definition.returnsDescription
  }), /*#__PURE__*/React.createElement(Members, {
    definition: returnType.reference || returnType,
    depth: depth + 1
  })));
}

export default TsDocReturnBlock;